import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { ContextService } from '../services/context.service';
import { RequestService } from '../services/request.service';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const cotGuard: CanActivateFn = async (route, state) => {
  const keycloak = inject(KeycloakService);
  const router = inject(Router);
  const contextService = inject(ContextService);
  const authService = inject(AuthService);

  const s = contextService.snapshot();
  const hasAnySelection = (['cot', 'uvm', 'pua', 'bm', 'ward', 'mmg'] as const).some(
    (k) => !!s[k].selected
  );
  if (!hasAnySelection && !authService.isOperatoreSuperUser) {
    router.navigate(['/context']);
    return false;
  }

  return true;
};
